// Social media utility functions
export function extractMentions(text) {
    var mentionRegex = /@(\w+)/g;
    var mentions = [];
    var match;
    while((match = mentionRegex.exec(text)) !== null){
        mentions.push(match[1]);
    }
    return mentions;
}
export function extractHashtags(text) {
    var hashtagRegex = /#(\w+)/g;
    var hashtags = [];
    var match;
    while((match = hashtagRegex.exec(text)) !== null){
        hashtags.push(match[1]);
    }
    return hashtags;
}
export function formatTweetText(text) {
    return text.replace(/@(\w+)/g, '<span class="mention">@$1</span>').replace(/#(\w+)/g, '<span class="hashtag">#$1</span>').replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
}
export function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength - 3) + '...';
}
export function isValidTweetLength(text) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 280;
    return text.length <= maxLength;
}
export function getTweetCharacterCount(text) {
    // URLs count as 23 characters in Twitter
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urlCount = (text.match(urlRegex) || []).length;
    var textWithoutUrls = text.replace(urlRegex, '');
    return textWithoutUrls.length + urlCount * 23;
}
export function formatRelativeTime(date) {
    var now = new Date();
    var diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    if (diffInSeconds < 60) {
        return "".concat(diffInSeconds, "s");
    } else if (diffInSeconds < 3600) {
        return "".concat(Math.floor(diffInSeconds / 60), "m");
    } else if (diffInSeconds < 86400) {
        return "".concat(Math.floor(diffInSeconds / 3600), "h");
    } else if (diffInSeconds < 2592000) {
        return "".concat(Math.floor(diffInSeconds / 86400), "d");
    } else {
        return date.toLocaleDateString();
    }
}
export function formatNumber(num) {
    if (num < 1000) {
        return num.toString();
    } else if (num < 1000000) {
        return "".concat((num / 1000).toFixed(1), "K");
    } else {
        return "".concat((num / 1000000).toFixed(1), "M");
    }
}
// URL 추출 함수 - Enhanced version from shared/social-utils
export function extractFirstUrl(text) {
    if (!text) return null;
    var urlRegex = /https?:\/\/[^\s]+/g;
    var matches = text.match(urlRegex);
    return matches ? matches[0] : null;
}
/**
 * 텍스트에서 모든 URL을 추출하는 함수
 * @param text 검색할 텍스트
 * @returns 찾은 모든 URL 배열
 */ export function extractAllUrls(text) {
    if (!text) return [];
    var urlRegex = /https?:\/\/[^\s]+/g;
    var matches = text.match(urlRegex);
    return matches || [];
}
/**
 * YouTube URL인지 확인하는 함수
 * @param url 확인할 URL
 * @returns YouTube URL 여부
 */ export function isYouTubeUrl(url) {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be');
}
/**
 * 소셜 미디어 플랫폼을 감지하는 함수
 * @param url 확인할 URL
 * @returns 플랫폼 이름 또는 'unknown'
 */ export function detectSocialPlatform(url) {
    if (!url) return 'unknown';
    var lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be')) {
        return 'youtube';
    } else if (lowerUrl.includes('twitter.com') || lowerUrl.includes('x.com')) {
        return 'twitter';
    } else if (lowerUrl.includes('facebook.com')) {
        return 'facebook';
    } else if (lowerUrl.includes('instagram.com')) {
        return 'instagram';
    } else if (lowerUrl.includes('linkedin.com')) {
        return 'linkedin';
    } else if (lowerUrl.includes('tiktok.com')) {
        return 'tiktok';
    }
    return 'website';
}
// Keyword type prefixes
export var MENTION_PREFIX = '@';
export var HASHTAG_PREFIX = '#';
export var PROJECT_PREFIX = '$';
/**
 * Extract mention/hashtag/project token information at current cursor position
 * @param text Current text input value
 * @param cursorPosition Current cursor position
 * @returns Token meta information or null
 */ export function extractTokenAtCursor(text, cursorPosition) {
    if (!text || cursorPosition === undefined || cursorPosition > text.length) {
        console.log('Invalid input:', {
            text: text,
            cursorPosition: cursorPosition
        });
        return null;
    }
    // Extract text before cursor position
    var textBeforeCursor = text.substring(0, cursorPosition);
    // Extract text after last space
    var lastSpaceIndex = Math.max(textBeforeCursor.lastIndexOf(' '), textBeforeCursor.lastIndexOf('\n'));
    var currentToken = textBeforeCursor.substring(lastSpaceIndex + 1);
    console.log('Token extraction info:', {
        textLength: text.length,
        cursorPosition: cursorPosition,
        currentToken: currentToken,
        tokenStartPosition: lastSpaceIndex + 1
    });
    // Special characters alone (@, #, $)
    if (currentToken === MENTION_PREFIX) {
        console.log('Mention token detected (standalone)');
        return {
            type: 'mention',
            token: '',
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    } else if (currentToken === HASHTAG_PREFIX) {
        console.log('Hashtag token detected (standalone)');
        return {
            type: 'hashtag',
            token: '',
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    } else if (currentToken === PROJECT_PREFIX) {
        console.log('Project token detected (standalone)');
        return {
            type: 'project',
            token: '',
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    }
    // Check mention, hashtag, project reference (allow empty tokens)
    if (currentToken.startsWith(MENTION_PREFIX)) {
        console.log('Mention token detected (with text):', currentToken.substring(1));
        return {
            type: 'mention',
            token: currentToken.substring(1),
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    } else if (currentToken.startsWith(HASHTAG_PREFIX)) {
        console.log('Hashtag token detected (with text):', currentToken.substring(1));
        return {
            type: 'hashtag',
            token: currentToken.substring(1),
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    } else if (currentToken.startsWith(PROJECT_PREFIX)) {
        console.log('Project token detected (with text):', currentToken.substring(1));
        return {
            type: 'project',
            token: currentToken.substring(1),
            startPosition: lastSpaceIndex + 1,
            endPosition: cursorPosition
        };
    }
    console.log('Token detection failed');
    return null;
}
/**
 * Insert token (mention/hashtag/project) into text
 * @param text Current text
 * @param token Token meta information to insert
 * @param selectedValue Selected value
 * @returns New text with token inserted and new cursor position
 */ export function insertTokenIntoText(text, token, selectedValue) {
    if (!token || !selectedValue) {
        return {
            newText: text,
            newPosition: text.length
        };
    }
    var prefix = token.type === 'mention' ? MENTION_PREFIX : token.type === 'hashtag' ? HASHTAG_PREFIX : PROJECT_PREFIX;
    var replacement = "".concat(prefix).concat(selectedValue, " ");
    var newText = text.substring(0, token.startPosition) + replacement + text.substring(token.endPosition);
    var newPosition = token.startPosition + replacement.length;
    return {
        newText: newText,
        newPosition: newPosition
    };
}
/**
 * Extract all tokens from text (for text processing)
 * @param text Text to analyze
 * @returns Array of all found tokens
 */ export function extractAllTokens(text) {
    if (!text) return [];
    var tokens = [];
    // Mention pattern: @username (only alphanumeric, underscore, dash)
    var mentionPattern = /@([\w-]+)/g;
    var mentionMatch;
    while((mentionMatch = mentionPattern.exec(text)) !== null){
        tokens.push({
            type: 'mention',
            value: mentionMatch[1]
        });
    }
    // Hashtag pattern: #tag (alphanumeric, underscore, Korean allowed)
    var hashtagPattern = /#([a-zA-Z0-9_\u3131-\uD79D]+)/g;
    var hashtagMatch;
    while((hashtagMatch = hashtagPattern.exec(text)) !== null){
        tokens.push({
            type: 'hashtag',
            value: hashtagMatch[1]
        });
    }
    // Project reference pattern: $project (alphanumeric, underscore, Korean, dash allowed)
    var projectPattern = /\$([\w\u3131-\uD79D-]+)/g;
    var projectMatch;
    while((projectMatch = projectPattern.exec(text)) !== null){
        tokens.push({
            type: 'project',
            value: projectMatch[1]
        });
    }
    return tokens;
}
/**
 * Highlight tokens in text
 * @param text Original text
 * @returns Highlighted text as string
 */ export function highlightTokens(text) {
    if (!text) return '';
    // Highlight mentions
    text = text.replace(/@([\w-]+)/g, '<span class="text-blue-500">@$1</span>');
    // Highlight hashtags
    text = text.replace(/#([a-zA-Z0-9_\u3131-\uD79D]+)/g, '<span class="text-blue-500">#$1</span>');
    // Highlight project references
    text = text.replace(/\$([\w\u3131-\uD79D-]+)/g, '<span class="text-green-500">$$1</span>');
    return text;
}
